import './styles/ManageJobs.scss';

import { Grid, CircularProgress, Skeleton } from '@mui/material';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Waypoint } from 'react-waypoint';

import { useJobOfferingsQuery } from 'api/hooks/jobmarket/offers';
import { ErrorBoundary } from 'app/components';
import { RichList } from 'app/components/RichList';
import { NoItems } from 'app/components/RichList/components/NoItems';
import { ManageJobOfferItem } from 'app/components/RichList/items/ManageJobOfferItem';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { SortField, SortDirection } from './FilterHeader';
import { FilterHeader } from './FilterHeader';

export function ManageJobs() {
  const { t } = useTranslation();
  const titleInputState = useState('');
  const courseTypeHandler = useState('');
  const paidTypeHandler = useState('');
  const [sortField, setSortField] = useState<SortField>(null);
  const [sortDirection, setSortDirection] = useState<SortDirection>(null);

  const [numberOfJobOffersShown, setNumberOfJobOffersShown] = useState(12);

  const {
    data: jobOfferings,
    isFetching,
    isLoading,
    isFetched
  } = useJobOfferingsQuery({
    params: {
      withExpired: true,
      limit: numberOfJobOffersShown,
      offset: 0,
      search: titleInputState[0]?.length > 0 ? titleInputState[0] : undefined,
      paid: paidTypeHandler[0]?.length > 0 ? paidTypeHandler[0] : undefined,
      course: courseTypeHandler[0]?.length > 0 ? courseTypeHandler[0] : undefined,
      sort: sortField,
      sortOrder: sortDirection
    }
  });

  usePageHeading({
    className: 'manage-jobs',
    desktopOnly: true,
    heading: t(translations.layout.menu.manageJobs())
  });

  return (
    <ErrorBoundary boundaryTag="jobListBoundary">
      <FilterHeader
        search={titleInputState[0]}
        setSearch={titleInputState[1]}
        paid={paidTypeHandler[0]}
        setPaid={paidTypeHandler[1]}
        sortField={sortField}
        setSortField={setSortField}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        course={courseTypeHandler[0]}
        setCourse={courseTypeHandler[1]}
      />
      <RichList onFilterChange={values => {}} onSortChange={values => {}}>
        {jobOfferings?.data.length === 0 ? (
          <NoItems />
        ) : (
          <>
            {isLoading &&
              Array.from({ length: 8 }).map((_, index) => (
                <Skeleton key={index} height={90} sx={{ transform: 'none', marginBottom: 1 }} />
              ))}
            {jobOfferings?.data.map(o => (
              <ManageJobOfferItem offer={o} key={o.id} />
            ))}
            {isFetched && jobOfferings?.data.length === numberOfJobOffersShown && (
              <Waypoint
                bottomOffset={'-3%'}
                onEnter={() => {
                  setNumberOfJobOffersShown(offset => offset + numberOfJobOffersShown);
                }}
              />
            )}
            {isFetching && (
              <Grid container justifyContent="center">
                <CircularProgress />
              </Grid>
            )}
          </>
        )}
      </RichList>
    </ErrorBoundary>
  );
}
